import { render } from "./SaveQualificationSkill.vue?vue&type=template&id=9e79772e"
import script from "./SaveQualificationSkill.vue?vue&type=script&lang=js"
export * from "./SaveQualificationSkill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__